
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0D47A1] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <span className="text-[#0D47A1] font-bold text-lg">ع</span>
              </div>
              <span className="font-bold text-xl">متجر العمران</span>
            </div>
            <p className="text-white/80 text-sm leading-relaxed mb-4">
              وجهتك الأولى للأجهزة المنزلية، تجهيزات السوبرماركت، وحلول المشاريع الكبرى. نقدم أفضل المنتجات بأسعار منافسة مع ضمان الجودة.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#FF8F00] transition-colors cursor-pointer">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#FF8F00] transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#FF8F00] transition-colors cursor-pointer">
                <i className="ri-snapchat-line"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center hover:bg-[#FF8F00] transition-colors cursor-pointer">
                <i className="ri-whatsapp-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">روابط سريعة</h4>
            <ul className="space-y-2">
              <li><Link to="/categories" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">جميع الأقسام</Link></li>
              <li><Link to="/offers" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">العروض والخصومات</Link></li>
              <li><Link to="/quote-request" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">طلب عرض سعر</Link></li>
              <li><Link to="/track-order" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">تتبع طلبك</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">من نحن</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">اتصل بنا</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-bold text-lg mb-4">الأقسام الرئيسية</h4>
            <ul className="space-y-2">
              <li><Link to="/categories/home-appliances" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">الأجهزة المنزلية</Link></li>
              <li><Link to="/categories/supermarket" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">تجهيزات السوبرماركت</Link></li>
              <li><Link to="/categories/projects" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">حلول المشاريع</Link></li>
              <li><Link to="/categories/refrigerators" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">الثلاجات</Link></li>
              <li><Link to="/categories/air-conditioners" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">المكيفات</Link></li>
              <li><Link to="/categories/cooling-rooms" className="text-white/80 hover:text-[#FF8F00] transition-colors cursor-pointer">غرف التبريد</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-lg mb-4">تواصل معنا</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-[#FF8F00]"></i>
                </div>
                <span className="text-white/80 text-sm">المملكة العربية السعودية، الرياض</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-[#FF8F00]"></i>
                </div>
                <span className="text-white/80 text-sm">920000000</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-[#FF8F00]"></i>
                </div>
                <span className="text-white/80 text-sm">info@alomran.sa</span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-[#FF8F00]"></i>
                </div>
                <span className="text-white/80 text-sm">السبت - الخميس: 9 ص - 10 م</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Payment Methods */}
      <div className="border-t border-white/20">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <span className="text-white/80 text-sm">طرق الدفع:</span>
              <div className="flex items-center gap-2">
                <div className="bg-white rounded px-2 py-1">
                  <i className="ri-visa-line text-[#0D47A1] text-xl"></i>
                </div>
                <div className="bg-white rounded px-2 py-1">
                  <i className="ri-mastercard-line text-[#0D47A1] text-xl"></i>
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-[#0D47A1]">
                  Apple Pay
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-[#0D47A1]">
                  STC Pay
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-white/80 text-sm">الشحن:</span>
              <div className="flex items-center gap-2">
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-[#0D47A1]">
                  أرامكس
                </div>
                <div className="bg-white rounded px-2 py-1 text-xs font-bold text-[#0D47A1]">
                  سمسا
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="bg-[#0a3a8a] py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-2 text-sm text-white/60">
            <p>© 2024 متجر العمران. جميع الحقوق محفوظة.</p>
            <div className="flex items-center gap-4">
              <Link to="/privacy" className="hover:text-white cursor-pointer">سياسة الخصوصية</Link>
              <Link to="/terms" className="hover:text-white cursor-pointer">الشروط والأحكام</Link>
              <a href="https://readdy.ai/?origin=logo" rel="nofollow" className="hover:text-white cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
